const VerifiedBadgeSvg = ({
  height = 21,
  width = 22,
  viewBox = '0 0 22 21',
  fill = '#F54900',
  className,
}: {
  height?: any;
  width?: any;
  viewBox?: any;
  fill?: any;
  className?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" className={className}>
      <path
        d="M7.6 21L5.7 17.8L2.1 17L2.45 13.3L0 10.5L2.45 7.7L2.1 4L5.7 3.2L7.6 0L11 1.45L14.4 0L16.3 3.2L19.9 4L19.55 7.7L22 10.5L19.55 13.3L19.9 17L16.3 17.8L14.4 21L11 19.55L7.6 21ZM9.95 14.05L15.6 8.4L14.2 6.95L9.95 11.2L7.8 9.1L6.4 10.5L9.95 14.05Z"
        fill={fill}
      />
    </svg>
  );
};

export default VerifiedBadgeSvg;
